module.exports = __webpack_public_path__ + "assets/fonts/AvantGardeGothicC-DemiOblique.b4415d4e.otf";